
<button class="btn btn-info" style="background-color :rgb(45, 145, 92)!important"(click)="export()">
<mat-icon>get_app</mat-icon> .xlsx
</button>